const init = () => {
    const hash = window.location.hash;
    if (!hash.length) return;

    window.scrollTo(0, 0);

    const target = document.querySelector(hash);
    if (target) {
        window.scrollTo(0, target.offsetTop - 50);
    };
};

const module = () => {
    window.addEventListener('load', init);
    document.addEventListener('domUpdated', init);
};

export default module;